import { render, staticRenderFns } from "./CircularListCard.vue?vue&type=template&id=6ee61f09"
import script from "./CircularListCard.vue?vue&type=script&lang=js"
export * from "./CircularListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default})
